export enum PaymentType {
  Billing = 'Billing',
  Upfront = 'Upfront',
  EquipmentUpgrade = 'EquipmentUpgrade',
  PayWithNextInvoice = 'PayWithNextInvoice',
}

export enum PaymentTypeName {
  Billing = 'Faktura',
  Upfront = 'Betal nå',
  EquipmentUpgrade = 'Mobilbytte',
  PayWithNextInvoice = 'Betales på neste faktura',
}

export enum UpfrontPaymentMethod {
  CreditCard = 'CreditCard',
  Vipps = 'Vipps',
  Klarna = 'Klarna',
  NoUpfrontPayment = 'NoUpfrontPayment',
}
